import React, { Component } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import classnames from "classnames";
import { ExecuteRequest } from "core/glambox/GlamboxApi";
import { GlamboxEndpoints } from "core/glambox/GlamboxEndpoints";
import { UiActions } from "state/actions/UiActions";
import { Modal } from "components/modal/Modal";
import { Glampoints } from "components/icons/Glampoints";

import ProductStyles from "components/glamclub/ProductDetails.module.scss";
import { TokenActions } from "state/actions/user/TokenActions";

export class ProductDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tradeProductModalVisible: false,
      disableTradeBtn: false,
    };
    this.renderExchangeButton = this.renderExchangeButton.bind(this);
  }

  toggleTradeProductModal = () => {
    this.setState({
      tradeProductModalVisible: !this.state.tradeProductModalVisible,
    });
  };

  renderExchangeButton(tradePoints) {
    const { person } = this.props;

    if (person.person.personStatus !== 4 && person.person.personStatus !== 14) {
      return (
        <div className={ProductStyles["product-detail__warning"]}>
          <div
            className={classnames(
              ProductStyles["product-detail__warning-text"],
              "p-2",
              "level-2",
              "text-center"
            )}
          >
            <p>
              <strong>Ops!</strong>
            </p>
            <p>
              Você precisa ser uma assinante ativa para efetuar trocas no
              GlamClub!
            </p>
          </div>
        </div>
      );
    }

    if (
      tradePoints - person.person.rewardBalance <= 0 &&
      (person.person.personStatus === 4 || person.person.personStatus === 14)
    ) {
      return (
        <p className={"text-center text-lg-left"}>
          <button
            className={"btn btn-light-lime btn-lg"}
            onClick={this.toggleTradeProductModal}
            disabled={this.state.disableTradeBtn}
          >
            Trocar | {tradePoints} GlamPoints
          </button>
        </p>
      );
    }

    return (
      <div className={ProductStyles["product-detail__warning"]}>
        <div
          className={classnames(
            ProductStyles["product-detail__warning-text"],
            "p-2",
            "level-2",
            "text-center"
          )}
        >
          <p>
            <strong>
              <span>Faltam</span>{" "}
              {Math.abs(tradePoints - person.person.rewardBalance)} Glampoints!
            </strong>
          </p>
          <p>
            Seu <strong>saldo é insuficiente</strong> para efetuar a troca por
            este produto.
            <br /> Para ganhar mais Glampoints, você pode:
          </p>
        </div>
        <div className={ProductStyles["product-detail__warning-actions"]}>
          <section className={"level-2"}>
            <strong>
              <Glampoints opacity={"0.1"} />
            </strong>
            <div>
              <p>
                Indicar suas amigas para
                <br /> assinarem a Glambox!
              </p>
              <span>
                Ganhe até
                <br /> 200 Glampoints
              </span>
            </div>
            <NavLink
              to={"/chama-as-amigas"}
              className={"btn btn-light-lime btn-sm"}
            >
              Indicar
            </NavLink>
          </section>
          <section className={"level-2"}>
            <strong>
              <Glampoints opacity={"0.1"} />
            </strong>
            <div>
              <p>
                Responder os feedbacks
                <br /> de produtos e das edições!
              </p>
              <span>
                Ganhe até
                <br /> 20 Glampoints
              </span>
            </div>
            <NavLink to={"/edicoes"} className={"btn btn-light-lime btn-sm"}>
              Responder
            </NavLink>
          </section>
          <section className={"level-2"}>
            <strong>
              <Glampoints opacity={"0.1"} />
            </strong>
            <div>
              <p>
                Postar a Hashtag do mês
                <br /> no seu Instagram!
              </p>
              <span>
                Ganhe até
                <br /> 30 Glampoints
              </span>
            </div>
            <a
              href={"https://minha.glambox.com.br/ganhe-mais-glampoints"}
              target={"_blank"}
              className={"btn btn-light-lime btn-sm"}
            >
              Postar
            </a>
          </section>
          {/*<button>
            Indicar Amigas
            <span className={ProductStyles["small"]}>
              Até 200 Glampoints
            </span>
          </button>
          <button>
            Responder Pesquisas
            <span className={ProductStyles["small"]}>
              Até 20 Glampoints
            </span>
          </button>
          <button>
            Postar Hashtag
            <span className={ProductStyles["small"]}>
              Até 200 Glampoints
            </span>
          </button>*/}
        </div>
      </div>
    );
  }

  tradeProduct = (event) => {
    event.preventDefault();
    const { person, token } = this.props;
    let { disableTradeBtn } = this.state;

    if (disableTradeBtn === true) return null;

    this.props.loaderShow();
    this.props.loadingStatusSet(true);

    this.setState({ disableTradeBtn: true });

    // TODO
    ExecuteRequest(
      GlamboxEndpoints.GlamClub.productTrade,
      null,
      "POST",
      {
        Authorization: token.Authorization,
      },
      {
        productVariantId: this.props.product.productVariantId,
      },
      (response) => {
        const { result, statusCode } = response;

        if (statusCode === 200) {
          this.props.successAlert("Troca Realizada com Sucesso!");
        } else {
          this.props.errorAlert(
            result && result.message
              ? result.message
              : "Não foi possível trocar o produto."
          );
        }

        this.setState({ disableTradeBtn: false });
        this.props.loadingStatusSet(false);
        this.props.loaderHide();
        this.props.refreshAllData(token.Authorization, token.personId);
        this.toggleTradeProductModal();
      }
    );
  };

  render() {
    const { product } = this.props;
    let imageUrl = product.defaultImageURL.replace(/\_SML/, "_BIG");

    let expirationDate =
      product.expirationDate !== null ? (
        <p>
          Validade: <strong>{product.expirationDate}</strong>
        </p>
      ) : null;

    return (
      <div className={ProductStyles["product-detail"]}>
        <div className={ProductStyles["product-detail__image"]}>
          <figure className={"level-2"}>
            <img src={imageUrl} alt={""} />
          </figure>
        </div>

        <div className={ProductStyles["product-detail__info"]}>
          <h2 className={"text-center text-lg-left"}>
            {product.productVariantName}
          </h2>

          {this.renderExchangeButton(product.tradePoints)}

          {expirationDate}

          <div
            className={"product-detail__text"}
            dangerouslySetInnerHTML={{ __html: product.articleBody }}
          ></div>
        </div>

        <Modal
          visible={this.state.tradeProductModalVisible}
          onCloseModal={this.toggleTradeProductModal}
        >
          <div>
            <h4 className={"text-center"}>
              Você tem certeza de que deseja trocar{" "}
              <strong> {product.tradePoints} </strong> glampoints pelo produto
              <strong> {product.productVariantName}</strong>?
            </h4>

            <p className={"text-center"}>
              <button
                onClick={this.tradeProduct}
                className={"btn btn-sm btn-light-lime"}
                disabled={this.state.disableTradeBtn}
              >
                Sim
              </button>
              &nbsp;
              <button
                onClick={this.toggleTradeProductModal}
                className={"btn btn-sm btn-outline-light-pink"}
              >
                Não
              </button>
            </p>
          </div>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  person: state.person.data,
  token: state.token.data,
});

const mapDispatchToProps = (dispatch) => {
  return {
    refreshAllData: (token, personId) => {
      dispatch(TokenActions.identifyTokenAndPersonId(token, personId));
    },
    successAlert: (message) => {
      dispatch(UiActions.publishSuccessAlert(message));
    },
    errorAlert: (message) => {
      dispatch(UiActions.publishErrorAlert(message));
    },
    loaderHide: () => {
      dispatch(UiActions.loaderHide());
    },
    loaderShow: () => {
      dispatch(UiActions.loaderShow());
    },
    loadingStatusSet: (status) => {
      dispatch(UiActions.setLoadingStatus(status));
    },
  };
};

ProductDetails = connect(mapStateToProps, mapDispatchToProps)(ProductDetails);
